document.addEventListener("DOMContentLoaded", () => {
  const videoWrapper = document.querySelectorAll(
    ".multiple-videos-general__video-embed"
  );
  const iframeWrapper = document.querySelector(
    ".multiple-videos-general__iframe-wrapper"
  );
  const iframe = iframeWrapper.querySelector("iframe");
  const video = iframeWrapper.querySelector("video");

  const loadMoreButton = document.querySelector(
    ".multiple-videos-general__show-more-text"
  );
  const hiddenVideos = document.querySelectorAll(
    ".multiple-videos-general__videos.hidden-video"
  );

  let startIndex = 0;
  const increment = 4;

  videoWrapper.forEach((item) => {
    item.addEventListener("click", () => {
      iframeWrapper.classList.add("iframe-visible");

      if (item.dataset.videourlpath) {
        iframe.style.display = "none";
        video.style.display = "block";

        video.setAttribute("src", `${item.dataset.videourlpath}`);
        video.load();
        video.play();
      } else {
        video.style.display = "none";
        iframe.style.display = "block";

        iframe.setAttribute(
          "src",
          `https://www.youtube-nocookie.com/embed/${item.dataset.videoid}?autoplay=1`
        );
      }
    });
  });

  iframeWrapper.addEventListener("click", () => {
    iframeWrapper.classList.remove("iframe-visible");

    iframeWrapper.querySelector("video").setAttribute("src", "");
    iframeWrapper.querySelector("iframe").setAttribute("src", "");
  });

  if (loadMoreButton) {
    loadMoreButton.addEventListener("click", () => {
      hiddenVideos.forEach((video, index) => {
        if (index >= startIndex && index < startIndex + increment) {
          video.classList.remove("hidden-video");
        }
      });

      startIndex += increment;

      if (startIndex >= hiddenVideos.length) {
        loadMoreButton.style.display = "none";
      }
    });
  }
});
